var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconsOtherAudio = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08337 14.8176V6.63673C7.08337 6.2909 7.29671 5.9809 7.62004 5.8584L14.7034 3.16006C15.2492 2.95173 15.8334 3.35506 15.8334 3.9384V13.1459",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2232 11.6727C16.0367 12.4863 16.0367 13.8054 15.2232 14.619C14.4096 15.4326 13.0905 15.4326 12.2769 14.619C11.4633 13.8054 11.4633 12.4863 12.2769 11.6727C13.0905 10.8591 14.4096 10.8591 15.2232 11.6727",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47316 13.3392C7.28675 14.1528 7.28675 15.4719 6.47316 16.2855C5.65956 17.0991 4.34047 17.0991 3.52688 16.2855C2.71329 15.4719 2.71329 14.1528 3.52688 13.3392C4.34047 12.5256 5.65956 12.5256 6.47316 13.3392",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconsOtherAudio);
export default ForwardRef;